var React = require('react');

function BrandTwitter (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"brand_Twitter_Copy","transform":"translate(-304 -7211)"},React.createElement("g",{"id":"brand_Twitter"},React.createElement("g",{"id":"brand_Twitter_Background_Mask_2"},React.createElement("path",{"id":"brand_Twitter-2","d":"M18.454 2.688A4.3 4.3 0 0 0 20.341.314a8.591 8.591 0 0 1-2.725 1.041A4.3 4.3 0 0 0 10.3 5.27 12.184 12.184 0 0 1 1.456.786a4.3 4.3 0 0 0 1.328 5.73 4.276 4.276 0 0 1-1.943-.538v.054a4.294 4.294 0 0 0 3.443 4.208 4.3 4.3 0 0 1-1.938.074 4.3 4.3 0 0 0 4.009 2.98 8.61 8.61 0 0 1-5.33 1.837A8.715 8.715 0 0 1 0 15.072 12.147 12.147 0 0 0 6.579 17a12.127 12.127 0 0 0 12.21-12.211q0-.279-.013-.555a8.719 8.719 0 0 0 2.142-2.222 8.579 8.579 0 0 1-2.464.676z","className":"cls-1","transform":"translate(305.541 7215)"})))));
}

BrandTwitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BrandTwitter;

BrandTwitter.default = BrandTwitter;
